<sh-dropdown
    #dropdown
    [label]="label()"
    [disabled]="disabled() || isDisabled()"
    [attr.mandatory]="mandatory() ? true : null"
    [error]="error()"
    display="label"
    editable
    (input)="handleSearchInput($event)"
>
    <!-- Show loading indicator while resolving initial value -->
    @if (isLoadingValue() && !selectedTeam && !searchTerm()) {
        <sh-menu-item label="Loading..." [active]="true" disabled="true"></sh-menu-item>
    }

    <!-- Show selected team if exists and no search term -->
    @if (selectedTeam && !searchTerm()) {
        <sh-menu-item
            [label]="getTeamDisplayName(selectedTeam)"
            [value]="selectedTeam.id"
            [active]="true"
            (click)="handleClear()"
        ></sh-menu-item>
    }

    <!-- Show loading state -->
    @if (isLoading()) {
        <sh-menu-item label="Loading..." disabled="true"></sh-menu-item>
    }

    <!-- Show search results -->
    @if (!isLoading() && searchResults().length > 0) {
        @for (team of searchResults(); track team.id) {
            <sh-menu-item
                [label]="getTeamDisplayName(team)"
                [value]="team.id"
                [active]="isTeamActive(team.id)"
                (click)="handleTeamSelect(team)"
            ></sh-menu-item>
        }
    }

    <!-- Show no results message -->
    @if (!isLoading() && searchResults().length === 0 && !selectedTeam) {
        <sh-menu-item label="No teams found" disabled="true"></sh-menu-item>
    }
</sh-dropdown>
